import { Environment } from '../enums/environment';

const ENVIRONMENT_HOSTNAMES: Record<Environment, string> = {
    [Environment.LOCAL]: 'localhost',
    [Environment.DEV]: 'web.dev.shipit.gls-group.com',
    [Environment.STAGE]: 'web.stage.shipit.gls-group.com',
    [Environment.PROD]: 'web.shipit.gls-group.com'
};

export { ENVIRONMENT_HOSTNAMES };
